// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import FaceTemplate from "../containers/facesearch/FaceTemplate";

class FaceSearch extends Component<*> {
  render(): * {
    return (
      <UserAuth principal="online-user" unAuthChildren={<RedirectoLogin />}>
        <div className="app-main">
          <FaceTemplate />
        </div>
      </UserAuth>
    );
  }
}

export default FaceSearch;
